import _ from 'underscore';

export function normalizeConfig(config) {
  const {
    columns = config.columns,
    customColumnConfig = { enabled: false, debugMode: false },
    categories,
    selected,
    mandatoryProperties = [],
    locked = [],
    patchQuery = false,
    toolbar,
    Columns,
    SelectedColumns,
    LegacyColumns,
    LegacySelectedColumns,
    CustomColumns,
    AdCustomizerAttribute,
    resource,
    LegacyGridFlag,
    nameFromLegacy,
    legacyGridName,
    i18n,
    i18nErrors,
    customToolbarIcon,
    isForVNext,
    isHotelCenterGrid,
    columnProcessorBeforeSetRecord,
    RSAAdCustomizerAttributeColumn,
    enableRSAAdCustomizer,
    columnConversions,
  } = _.result(config.plugins, 'columnChooser', {});

  return {
    columns: _.isArray(columns) ? _.indexBy(columns, 'name') : columns,
    customColumnConfig,
    selected,
    mandatoryProperties,
    categories,
    locked,
    patchQuery,
    toolbar,
    Columns,
    SelectedColumns,
    LegacyColumns,
    legacyGridName,
    LegacySelectedColumns,
    LegacyGridFlag,
    nameFromLegacy,
    CustomColumns,
    AdCustomizerAttribute,
    resource,
    i18n,
    i18nErrors,
    customToolbarIcon,
    isForVNext,
    isHotelCenterGrid,
    columnProcessorBeforeSetRecord,
    RSAAdCustomizerAttributeColumn,
    enableRSAAdCustomizer,
    columnConversions,
  };
}
